<sh-alerts-details-feed
  #alertsDetailsFeedComponent
  (openEditAlert)="openAlertsEditor(true, $event)"
  (openNewAlert)="openAlertsEditor(false)"
></sh-alerts-details-feed>
<sh-alerts-editor-container
  #alertsEditorModal
  (close)="onAlertChangeClose()"
></sh-alerts-editor-container>
